import React from "react";
import { Form } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import {
  MdVisibility,
  MdModeEditOutline,
  MdDelete,
  MdContentCopy,
} from "react-icons/md";
import { FiInfo } from "react-icons/fi";
import { FaSearch } from "react-icons/fa";
import Pagination from "../../../../helper/Pagination";

const OEMPartnerTable = ({
  partners,
  loading,
  scanTypeFilter,
  setScanTypeFilter,
  statusFilter,
  setStatusFilter,
  searchTerm,
  handleSearchChange,
  scanTypes,
  copiedId,
  setCopiedId,
  handleViewDetails,
  handleEditClick,
  removePartner,
  handleStatusChange,
  currentPage,
  pagination,
  setCurrentPage,
  handleResendVerification,
}) => {
  return (
    <div className="table-section">
      <div className="d-flex justify-content-between gap-4 align-items-center mb-2">
        <div className="">
          <button
            className={`me-2 add-btn ${
              statusFilter === "active" ? "active" : ""
            }`}
            onClick={() =>
              setStatusFilter(statusFilter === "active" ? "" : "active")
            }
            style={{
              background:
                statusFilter === "active"
                  ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                  : statusFilter === "inactive"
                    ? "#f8f9fa"
                    : "",
              color:
                statusFilter === "active"
                  ? "white"
                  : statusFilter === "inactive"
                    ? "#666"
                    : "",
            }}
          >
            Active
          </button>
          <button
            className={`add-btn ${statusFilter === "inactive" ? "active" : ""}`}
            onClick={() =>
              setStatusFilter(statusFilter === "inactive" ? "" : "inactive")
            }
            style={{
              background:
                statusFilter === "inactive"
                  ? "linear-gradient(135deg, #1e40af, #3b82f6)"
                  : statusFilter === "active"
                    ? "#f8f9fa"
                    : "",
              color:
                statusFilter === "inactive"
                  ? "white"
                  : statusFilter === "active"
                    ? "#666"
                    : "",
            }}
          >
            Inactive
          </button>
        </div>

        <div className="d-flex gap-3">
          <select
            className="form-input"
            value={scanTypeFilter}
            onChange={(e) => setScanTypeFilter(e.target.value)}
            style={{ width: "200px" }}
          >
            <option value="">All Scan Types</option>
            {scanTypes.map((scanType) => (
              <option key={scanType._id} value={scanType.name}>
                {scanType.name}
              </option>
            ))}
          </select>
          <div className="position-relative">
            <input
              type="search"
              placeholder="Search by Name & Email..."
              className="form-input"
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "200px" }}
            />
            {searchTerm === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  color: "#666",
                  transform: "translateY(-50%)",
                }}
              >
                <FaSearch />
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="table-scroll-wrapper">
        <table className="partners-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Company Name</th>
              <th>Email</th>
              <th>Contact Number</th>
              <th>Country (Currency)</th>
              <th>Password</th>
              {scanTypeFilter !== "Multiple" && (
                <th>
                  Stripe Product ID{" "}
                  <span
                    className="text-white cursor-pointer info_pointer ms-1"
                    title="Stripe Product Id is assigned by Stripe and must be retrieved directly from Stripe"
                  >
                    <FiInfo />
                  </span>
                </th>
              )}
              <th>Verification Email</th>
              <th>Scan Type</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={scanTypeFilter === "Multiple" ? "11" : "12"}
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#666",
                  }}
                >
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                    <p>Loading...</p>
                  </div>
                </td>
              </tr>
            ) : partners.length === 0 ? (
              <tr>
                <td
                  colSpan={scanTypeFilter === "Multiple" ? "11" : "12"}
                  style={{
                    textAlign: "center",
                    padding: "20px",
                    color: "#666",
                  }}
                >
                  No partners added yet
                </td>
              </tr>
            ) : (
              partners
                .filter((partner) => partner && partner.companyName)
                .map((partner, index) => (
                  <tr key={partner._id}>
                    {/* <td>{index + 1}</td> */}
                      <td>
                    {(currentPage - 1) * 10 + index + 1}
                  </td>
                    <td
                      title={
                        partner.companyName && partner.companyName.length > 20
                          ? partner.companyName
                          : ""
                      }
                      style={{
                        cursor:
                          partner.companyName && partner.companyName.length > 20
                            ? "pointer"
                            : "default",
                      }}
                    >
                      {partner.companyName
                        ? partner.companyName.length > 20
                          ? partner.companyName.charAt(0).toUpperCase() +
                            partner.companyName.substring(1, 20) +
                            "..."
                          : partner.companyName.charAt(0).toUpperCase() +
                            partner.companyName.slice(1)
                        : "N/A"}
                    </td>
                    <td>{partner.email || "N/A"}</td>
                    <td>
                      {partner.countryCode && partner.contactNumber
                        ? `(${partner.countryCode}) ${partner.contactNumber}`
                        : partner.contactNumber || "N/A"}
                    </td>
                    <td>
                      {partner.country && partner.currency
                        ? `${partner.country} (${partner.currency})`
                        : partner.country || partner.currency || "N/A"}
                    </td>
                    <td>
                      <div className="password-cell">
                        <span>
                          {partner.plainPassword ? "************" : "N/A"}
                        </span>
                        {partner.plainPassword &&
                          partner.plainPassword !== "N/A" && (
                            <MdContentCopy
                              className="copy-icon"
                              style={{
                                color:
                                  copiedId === partner?._id
                                    ? "#28a745"
                                    : "#007bff",
                              }}
                              onClick={() => {
                                const text = partner.plainPassword;

                                // safe clipboard copy
                                if (
                                  typeof navigator !== "undefined" &&
                                  navigator.clipboard &&
                                  window.isSecureContext
                                ) {
                                  navigator.clipboard
                                    .writeText(text)
                                    .then(() => {
                                      setCopiedId(partner._id);
                                      setTimeout(() => setCopiedId(null), 2000);
                                    })
                                    .catch(() => {
                                      // fallback
                                      const textArea =
                                        document.createElement("textarea");
                                      textArea.value = text;
                                      textArea.style.position = "fixed";
                                      document.body.appendChild(textArea);
                                      textArea.focus();
                                      textArea.select();
                                      document.execCommand("copy");
                                      document.body.removeChild(textArea);

                                      setCopiedId(partner._id);
                                      setTimeout(() => setCopiedId(null), 2000);
                                    });
                                } else {
                                  // fallback always on http
                                  const textArea =
                                    document.createElement("textarea");
                                  textArea.value = text;
                                  textArea.style.position = "fixed";
                                  document.body.appendChild(textArea);
                                  textArea.focus();
                                  textArea.select();
                                  document.execCommand("copy");
                                  document.body.removeChild(textArea);

                                  setCopiedId(partner._id);
                                  setTimeout(() => setCopiedId(null), 2000);
                                }
                              }}
                              title={
                                copiedId === partner?._id
                                  ? "Copied!"
                                  : "Copy password"
                              }
                            />
                          )}
                      </div>
                    </td>

                    {scanTypeFilter !== "Multiple" && (
                      <td>
                        {partner.scanType === "Multiple" || partner.scanType === "License" ? (
                          "--"
                        ) : partner?.stripeProductId &&
                          Array.isArray(partner.stripeProductId) &&
                          partner.stripeProductId.length > 0 ? (
                          <div className="relative inline-flex items-center gap-2">
                            <span>
                              {partner.stripeProductId[0]}
                              {partner.stripeProductId.length > 1 && ","}
                            </span>
                            {partner.stripeProductId.length > 1 && (
                              <>
                                <span
                                  className="ml-2 text-white ms-1 rounded-1 text-xs font-bold p-1"
                                  data-tooltip-id={`stripe-tooltip-${partner._id}`}
                                  data-tooltip-content={partner.stripeProductId.join(
                                    ", ",
                                  )}
                                  style={{
                                    cursor: "pointer",
                                    backgroundColor: "rgb(74, 144, 226)",
                                  }}
                                >
                                  +{partner.stripeProductId.length - 1}
                                </span>

                                <Tooltip
                                  id={`stripe-tooltip-${partner._id}`}
                                  place="top"
                                  style={{
                                    backgroundColor: "black",
                                    color: "white",
                                    fontSize: "12px",
                                    borderRadius: "6px",
                                    padding: "6px 10px",
                                  }}
                                />
                              </>
                            )}
                          </div>
                        ) : partner?.stripeProductId ? (
                          partner.stripeProductId
                        ) : (
                          "N/A"
                        )}
                      </td>
                    )}
                    <td>
                      {!partner.verified ? (
                        <button
                          className=""
                          onClick={() => handleResendVerification(partner._id)}
                          style={{
                            padding: "4px 12px",
                            fontSize: "12px",
                            background: "linear-gradient(135deg, #1e40af, #3b82f6)",
                            border: "none",
                            borderRadius: "4px",
                            color: "white",
                            cursor: "pointer",
                          }}
                        >
                            Resend
                        </button>
                      ) : (
                        <span style={{ color: "#28a745", fontWeight: "bold" }}>Verified</span>
                      )}
                    </td>
                    <td>{partner.scanType || "N/A"}</td>
                    <td className="">
                      <Form.Switch
                        className={
                          partner?.status === "active"
                            ? "custom-active info_pointer"
                            : ""
                        }
                        checked={partner?.status === "active"}
                        onChange={() => handleStatusChange(partner)}
                      />
                    </td>
                    <td>
                      <div className="row-actions">
                        <div
                          onClick={() => handleViewDetails(partner)}
                          className="view-row-btn"
                          title="View Details"
                          style={{
                            color: "#666",
                            cursor: "pointer",
                            marginRight: "8px",
                          }}
                        >
                          <MdVisibility />
                        </div>
                        <div
                          onClick={() => handleEditClick(partner)}
                          className="edit-row-btn"
                          title="Edit"
                        >
                          <MdModeEditOutline />
                        </div>
                        <div
                          onClick={() => removePartner(partner)}
                          className="delete-row-btn"
                          title="Delete"
                        >
                          <MdDelete />
                        </div>
                      </div>
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </table>
      </div>

      <Pagination
        currentPage={currentPage}
        totalPages={pagination.totalPages}
        totalItems={pagination.totalItems}
        itemsPerPage={pagination.itemsPerPage}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default OEMPartnerTable;
